import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../redux/store';
import { selectBarChartDataPoints, selectPieChartataPointNodes, DataPoint, DataPointNode } from '../../../redux/VisualizationSlice';

//These selectors are used to select the data points for the bar chart and pie chart from the Redux store.
//They use the createSelector function from the reselect library to memoize the results and improve performance.

//Bar Chart Selectors
export const selectBarChartDataPointsSelector = createSelector(
    (state: RootState) => selectBarChartDataPoints(state),
    (barChartDataPoints: Array<DataPoint>) => barChartDataPoints
);

// Entity type numeric ranges used to bucket entities by type.
export const ENTITY_TYPE_RANGES: Record<string, [number, number] | null> = {
    ALL: null,
    COUNTIES: [100000, 199999],
    CITIES: [200000, 299999],
    SPECIAL_DISTRICTS: [300000, 399999],
    OTHER_ENTITIES: [500000, 599999],
};

// Parametric selector: given the current entityType value, returns the filtered + sorted
// bar chart data points. Because this is a pure function of (state, entityType), it produces
// the correct result on every call regardless of component mount/unmount timing.
export const selectFilteredSortedBarChartDataPoints = createSelector(
    [
        selectBarChartDataPointsSelector,
        (_state: RootState, entityType: string) => entityType,
    ],
    (barChartDataPoints: Array<DataPoint>, entityType: string) => {
        let filtered = barChartDataPoints.filter((dp) => dp.y !== 0);

        const range = ENTITY_TYPE_RANGES[entityType] ? ENTITY_TYPE_RANGES[entityType] : null;
        if (range) {
            const [min, max] = range;
            filtered = filtered.filter((dp) => dp.z != null && dp.z >= min && dp.z <= max);
        }

        return [...filtered].sort((a, b) => b.y - a.y);
    }
);

//Pie Chart Selectors
export const selectPieChartDataPointNodesSelector = createSelector(
    (state: RootState) => selectPieChartataPointNodes(state),
    (pieChartDataPointNodes: DataPointNode | null) => pieChartDataPointNodes
);